import { render, staticRenderFns } from "./terapeuta.vue?vue&type=template&id=bacca0a4&scoped=true&"
import script from "./terapeuta.vue?vue&type=script&lang=js&"
export * from "./terapeuta.vue?vue&type=script&lang=js&"
import style0 from "./terapeuta.vue?vue&type=style&index=0&id=bacca0a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacca0a4",
  null
  
)

export default component.exports